<!-- =========================================================================================
    Description: Parent page to prepare the data for EditSpaceChild.vue
========================================================================================== -->

<template>
  <div>
    <edit-space-child
      ref="editSpaceChild"
      v-if="isSpaceContentLoaded && space && nodes && anchors && hobjects && models"
      v-bind:anchorPidFloor="anchorPidFloor"
      v-bind:space="space"
      v-bind:nodes="nodes"
      v-bind:anchors="anchors"
      v-bind:hobjects="hobjects"
      v-bind:anchors_spaces="anchors_spaces"
    ></edit-space-child>
    <div v-else-if="!isSpaceContentLoaded" class="loading-message">
      <p>Loading space content...</p>
    </div>
  </div>
</template>

<script>
import EditSpaceChild from './EditSpaceChild.vue'

export default {
  data() {
    return {
      layer_name: JSON.parse(localStorage.getItem('layerInfo')).name,
      isSpaceContentLoaded: false,
    }
  },
  components: {
    EditSpaceChild,
  },
  computed: {
    space_pid: function() {
      return this.$route.params.pid
    },
    space() {
      if (this.$store.state.hoverlay) {
        return this.$store.state.hoverlay.spaces.find(space => space.pid == this.space_pid)
      } else return null
    },
    nodes() {
      if (this.$store.state.hoverlay) {
        return this.$store.state.hoverlay.nodes.filter(node => node.space_pid == this.space_pid)
      } else return null
    },
    anchors() {
      if (this.$store.state.hoverlay) {
        return this.$store.state.hoverlay.anchors
      } else return null
    },
    hobjects() {
      var h = []
      if (this.nodes && Array.isArray(this.nodes)) {
        this.nodes.forEach(node => {
          var tmp = this.$store.state.hoverlay.hobjects.find(hobject => hobject.pid == node.hobject_pid)
          if (tmp) h.push(tmp)
        })
      }
      return h
    },
    models() {
      if (this.$store.state.hoverlay) {
        return this.$store.state.hoverlay.models
      } else return null
    },
    anchors_spaces() {
      if (this.$store.state.hoverlay.anchors_spaces) {
        return this.$store.state.hoverlay.anchors_spaces
      } else return null
    },
    anchorPidFloor: function() {
      if (
        this.$store.state.hoverlay &&
        this.$store.state.hoverlay.anchors.find(anchor => anchor.anchor_type == 'floor')
      )
        return this.$store.state.hoverlay.anchors.find(anchor => anchor.anchor_type == 'floor').pid
      else return false
    },
  },
  mounted() {},
  destroyed() {
    this.isSpaceContentLoaded = false
  },

  async created() {
    this.isSpaceContentLoaded = false
    try {
      await this.getSpaceContent()
      this.isSpaceContentLoaded = true

      console.log('=== EditSpaceParent - Checking computed properties ===')
      console.log('isSpaceContentLoaded:', this.isSpaceContentLoaded)
      console.log('space:', this.space)
      console.log('nodes:', this.nodes)
      console.log('anchors:', this.anchors)
      console.log('hobjects:', this.hobjects)
      console.log('models:', this.models)
      console.log('anchors_spaces:', this.anchors_spaces)
      console.log('anchorPidFloor:', this.anchorPidFloor)
      console.log('=====================================================')

      // Fetch anchors if they do not exist already
      if (this.$store.state.hoverlay.anchors.find(anchor => anchor.anchor_type == 'floor') == undefined)
      // this.$store.dispatch('hoverlay/fetchAnchor', 'floor')
      // FORCE RETRIEVAL OF SHARED FLOOR ANCHOR FROM DATABASE
       await this.$store.dispatch('hoverlay/getAnchor', 'i2cxv')

    } catch (error) {
      console.error('Error loading space content:', error)
      this.$vs.loading.close()
      this.$vs.notify({
        title: 'Error',
        text: 'Failed to load space content. Please try refreshing the page.',
        color: 'danger',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
      })
    }
  },
  methods: {
    async getSpaceContent() {
      this.$vs.loading()
      var params = {
        layer_name: this.layer_name,
        pid: this.$route.params.pid,
      }

      try {
        console.log('Calling getAnchorSpace...')
        await this.$store.dispatch('hoverlay/getAnchorSpace', params.pid)
        console.log('getAnchorSpace completed successfully')
      } catch (error) {
        console.error('getAnchorSpace failed:', error)
        // Continue anyway to load space content
      }

      await this.$store.dispatch('hoverlay/getSpaceContent', params)
      this.$vs.loading.close()
    },
    confirmExitWithoutSave(next) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Save changes before closing?',
        text: "Your changes will be lost if you don't save them.",
        acceptText: 'Save',
        cancelText: "Don't save",
        accept: () => this.updateSpaceAndNodes(next),
        cancel: () => this.blockRoute(next),
      })
    },
    async updateSpaceAndNodes(next) {
      await this.$refs.editSpaceChild.updateSpaceAndNodes()
      next(true)
    },
    blockRoute(next) {
      this.nodes.forEach(node => {
        node.is_dirty = false
      })
      next(true)
    },
  },

  beforeRouteLeave(to, from, next) {
    var areNodesDirties = !this.$refs.editSpaceChild.isSaveButtonDisabled
    if (areNodesDirties) {
      this.confirmExitWithoutSave(next)
    } else {
      next(true)
    }
  },
}
</script>

<style lang="scss"></style>
